import type React from 'react';

import SortIcon from '../../../assets/images/sortIcon.svg';

interface SortItemProps {
  name: string;
  onClick: () => void;
  disabled?: boolean;
}

export const SortItem: React.FC<SortItemProps> = ({ name, onClick, disabled = false }) => {
  return (
    <button className="cursor-pointer border-none bg-transparent" disabled={disabled} onClick={onClick} type="button">
      <div className="flex flex-row items-center font-Lato">
        <p className="mr-[5px] font-bold">{name}</p>
        <img alt="sort" src={SortIcon} />
      </div>
    </button>
  );
};
